import { Text, Title } from '@common/ui'
import PayloadEditor from './PayloadEditor'
import { Language } from './LanguageSelect'

export const AssetSourceView = ({
  content,
  isLoading,
  defaultLanguage,
}: {
  content: string | undefined
  isLoading: boolean
  defaultLanguage?: Language
}) => (
  <>
    <Title order={4} style={{ flexShrink: 0 }}>
      Payload
    </Title>
    {isLoading ? (
      <Text size="sm" c="dimmed">
        Loading...
      </Text>
    ) : (
      <PayloadEditor value={content} editable={false} defaultLanguage={defaultLanguage} />
    )}
  </>
)
